export default function Credito(){
    return (
        <>
            <h1>Crédito</h1>
        </>
    )
}